/* Mint-Customers: danh sách khách. Màu chỉ var(--…); số đo theo board (CW 1240, đầu cột 42, dòng 49, chữ 13 / 12). */
.page { display: flex; flex-direction: column; gap: 14px; padding: 2px 0 24px; min-width: 0; }

.tb { display: flex; align-items: center; gap: 10px; height: 44px; }
.search { position: relative; display: flex; align-items: center; gap: 10px; width: 320px; height: 42px; box-sizing: border-box; padding: 0 6px 0 14px; border-radius: 12px; background: var(--card); box-shadow: var(--sh); color: var(--lb); }
.search input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; font-size: 13px; color: var(--tx); }
.hana { flex-shrink: 0; display: inline-flex; align-items: center; gap: 5px; height: 30px; padding: 0 9px; border: 0; border-radius: 9px; background: var(--pri-bg); color: var(--link); font: inherit; font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.filter { display: inline-flex; align-items: center; gap: 8px; height: 42px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--ctl); color: var(--tx); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.sum { display: flex; align-items: center; gap: 16px; margin-left: auto; font-size: 13px; color: var(--tx2); white-space: nowrap; }
.sum span { display: inline-flex; align-items: center; gap: 6px; }
.sum .sumHot { color: var(--err); }
.search input:focus-visible { outline: 0; }
.search:focus-within, .filter:focus-visible, .hana:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }

.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow: clip; }
.lock { display: flex; align-items: center; gap: 8px; padding: 10px 18px; background: var(--sub); color: var(--tx2); font-size: 12px; }

.table { width: 100%; border-collapse: collapse; table-layout: fixed; white-space: nowrap; }
.table th {
  position: sticky;
  top: var(--page-head-h, 0px);
  z-index: 2;
  box-sizing: border-box;
  height: 42px;
  padding: 0 14px;
  background: var(--card);
  color: var(--lb);
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  border-bottom: 1px solid var(--line);
}
.table td { height: 49px; padding: 0 14px; overflow: hidden; text-overflow: ellipsis; border-bottom: 1px solid var(--line); font-size: 13px; }
.right { text-align: right !important; }
.selCell { width: 46px; padding: 0 0 0 18px !important; }
.check { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); cursor: pointer; }
/* như board: ô chọn ẩn cho tới khi rê chuột / đang chọn / focus; thiết bị chạm luôn hiện */
@media (hover: hover) {
  .table:not(.picking) .check { opacity: 0; }
  .table:not(.picking) tr:hover .check, .table .check:focus-visible { opacity: 1; }
}
.rowOn td { background: var(--pri-bg); }
@media (hover: hover) {
  .table tbody tr:not(.rowOn):hover td { background: var(--sub); }
  .mini:hover, .pg:hover:not(:disabled) { background: var(--ctl); }
}

.who { display: flex; align-items: center; gap: 10px; }
.sq { flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 9px; background: var(--sub); color: var(--tx2); font-size: 11px; font-weight: var(--fw-title); }
.whoTx { min-width: 0; flex: 1; }
.nameRow { display: flex; align-items: center; gap: 4px; }
.name { min-width: 0; padding: 0; border: 0; background: transparent; font: inherit; font-weight: var(--fw-label); color: var(--link); cursor: pointer; overflow: hidden; text-overflow: ellipsis; }
.name:focus-visible, .mini:focus-visible, .pg:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; border-radius: 6px; }
.mini { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; padding: 0; border: 0; border-radius: 7px; background: transparent; color: var(--lb); cursor: pointer; }
.sub { display: flex; align-items: center; gap: 4px; min-width: 0; font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; }
.sub svg { flex-shrink: 0; }
.flag { display: inline-flex; margin-left: 2px; }
.flag.warn { color: var(--warn); }
.flag.err { color: var(--err); }
.flag.lb { color: var(--lb); }

.person { display: inline-flex; align-items: center; gap: 6px; min-width: 0; white-space: nowrap; }
.person > span:last-child { overflow: hidden; text-overflow: ellipsis; }
.ab { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 50%; background: var(--pri-bg); color: var(--link); font-size: 10px; font-weight: var(--fw-title); }
.jobs { font-weight: var(--fw-label); }
.limit { display: inline-flex; align-items: center; gap: 4px; font-weight: var(--fw-label); color: var(--tx2); }
.od { display: flex; align-items: center; justify-content: flex-end; gap: 4px; font-weight: var(--fw-label); }
.hold { display: flex; align-items: center; justify-content: flex-end; gap: 4px; font-size: 12px; }
.err { color: var(--err); }
.lb { color: var(--lb); }
.upd { color: var(--tx2); }

.my { display: inline-flex; align-items: center; gap: 6px; padding: 3px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); }
.myTx { display: inline-flex; align-items: center; gap: 4px; }
.dot { width: 7px; height: 7px; border-radius: 50%; }
.my_ok { background: var(--ok-bg); color: var(--ok); }
.my_ok .dot { background: var(--ok-dot); }
.my_warn { background: var(--warn-bg); color: var(--warn); }
.my_warn .dot { background: var(--warn); }
.my_none { background: var(--sub); color: var(--lb); }
.my_none .dot { background: var(--lb); }

.foot { display: flex; align-items: center; justify-content: space-between; padding: 0 18px; height: 44px; box-sizing: border-box; font-size: 13px; color: var(--tx2); }
.pager { display: flex; gap: 8px; }
.pg { display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border: 0; border-radius: 10px; background: var(--ctl); color: var(--tx2); cursor: pointer; }
.pg:disabled { opacity: 0.5; cursor: default; }

@media (max-width: 1279px) {
  .table { min-width: 960px; }
  .card { overflow-x: auto; }
}
